import { memo, ReactNode } from 'react'

import { m, AnimatePresence, LazyMotion } from 'motion/react'
import { createStyles } from 'utils/css'
const loadFeatures = () => import('utils/animations').then(res => res.default)

interface IAnimate {
  children: ReactNode
  delay?: number
  duration?: number
  open: boolean
  styles?: any
  overflow?: string
}
const wrapper = overflow =>
  createStyles(() => ({ overflow: overflow && overflow }))

const SlideDown = ({
  children,
  delay,
  duration = 0.25,
  open,
  overflow,
  styles
}: IAnimate) => (
  <div css={wrapper(overflow)}>
    <LazyMotion features={loadFeatures}>
      <AnimatePresence initial={false}>
        {open && (
          <m.div
            css={styles}
            initial='collapsed'
            animate='open'
            exit='collapsed'
            variants={{
              open: {
                opacity: 1,
                height: 'auto'
              },
              collapsed: {
                opacity: 0,
                height: 0,
                transition: {
                  when: 'afterChildren',
                  delay
                }
              }
            }}
            transition={{ duration, ease: 'linear' }}
          >
            {children}
          </m.div>
        )}
      </AnimatePresence>
    </LazyMotion>
  </div>
)

export default memo(SlideDown)
